import React from 'react';
import { Row, Col } from 'reactstrap';
import UserRankingBar from '../ButtonBar/UserRankingBar.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import ConfirmButton from '../ConfirmButton/ConfirmButton.js';

const MediaRanking = ({ media, getArtists }) => {

    const removeMedia = (mediaGUID) => {
        fetch(`/api/media/${mediaGUID}`, {
            method: 'DELETE',
        })
            .then((response) => {
                if (response.ok) { // Checks if the status is in the range 200-299
                    getArtists();
                    return null;
                } else {
                    return null;
                }
            })
            .catch((error) => {
            });
    };

    return (
        <Row>
            <Col md={7}>
                <iframe
                    key={media.mediaGUID}
                    width="100%"
                    height="120"
                    scrolling="no"
                    frameBorder="no"
                    allow="autoplay"
                    src={`https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/${media.mediaURL}&auto_play=false&hide_related=true&show_comments=false&show_user=false&show_reposts=false&show_teaser=false&show_artwork=false&visual=false&download=false&sharing=false`}>
                </iframe>
            </Col>
            <Col>
                <Row className='mb-3'>
                    <Col>
                        <UserRankingBar
                            selectedValue={media.userRankingRank}
                            userRankingGUID={media.userRankingGUID}
                            mediaGUID={media.mediaGUID}
                            getArtists={() => getArtists()}
                        />
                        <ConfirmButton
                            className='ms-4'
                            color="danger"
                            onClick={() => removeMedia(media.mediaGUID)}
                        ><FontAwesomeIcon icon={faTrashAlt} /></ConfirmButton>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default MediaRanking;
